/**
 * Toast - Simple notification toast
 *
 * @module components/Toast
 */

import React from 'react';

import { AlertCircle, X } from 'lucide-react';

/**
 * Toast Component
 *
 * @param {Object} props
 * @param {string} props.message - Message to display
 * @param {Function} props.onClose - Close handler
 * @param {'error'|'success'|'warning'|'info'} props.type - Toast type
 */
const Toast = ({ message, onClose, type = 'error' }) => {
  const colors = {
    error: 'bg-red-500',
    success: 'bg-green-500',
    warning: 'bg-amber-500',
    info: 'bg-blue-500',
  };

  return (
    <div
      className={`fixed bottom-4 right-4 ${colors[type]} text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 z-50`}
    >
      <AlertCircle className="h-4 w-4" />
      <span>{message}</span>
      <button onClick={onClose} className="hover:opacity-80">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default Toast;
